<template>
    <div>
        <div class="subheader position-relative">
            <h1 class="text-center text-white position-relative">
                {{ $t("navbar.contact") }}
            </h1>
        </div>
        <div class="bg-vanilla">
            <div class="container p-md-5 py-3">
                <div class="row">
                    <div class="col-lg-6 col-12 mt-2 mb-2 text-brown">
                        <h2>{{ $t("contact.info") }}</h2>
                        <p>{{ $t("contact.subtext") }}</p>
                        <ul class="list p-0 m-0">
                           <li>
                                <i class="fa fa-phone text-brown"></i>
                                <a href="tel:+36703121117" class="text-brown text-decoration-none">+36-70-312-1117</a>
                            </li>
                            <li>
                                <i class="fa fa-map-marker text-brown"></i>
                                <a href="https://goo.gl/maps/NAAMzi59R6Dzf6Pz8" target="_blank" class="text-brown text-decoration-none">{{ $t("contact.address") }}</a>
                            </li>
                            <li>
                                <i class="fa fa-envelope text-brown"></i>
                                <a href="mailto:info@ijaszat.eu" class="text-brown text-decoration-none">info@ijaszat.eu</a>
                            </li>
                        </ul>
                        <p class="pt-3">{{ $t("contact.info_text") }}</p>
                    </div>
                    <div class="col-lg-4 col-12 mt-2 mb-2 text-brown offset-lg-1">
                        <h2>{{ $t("contact.open") }}</h2>
                        <ul class="list p-0 m-0">
                            <li>{{ $t("contact.mon") }}</li>
                            <li>{{ $t("contact.tue") }}</li>
                            <li>{{ $t("contact.wed") }}</li>
                            <li>{{ $t("contact.thu") }}</li>
                            <li>{{ $t("contact.fri") }}</li>
                            <li>{{ $t("contact.sat") }}</li>
                            <li>{{ $t("contact.sun") }}</li>
                        </ul>
                    </div>
                    <div class="col-12 mt-2 mb-2">
                        <iframe src="https://snazzymaps.com/embed/227947" width="100%" height="400px" style="border:none;"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Bus }  from "../bus.js";

    export default {
        data: function(){
            return {
                lang: ""
            }
        },
        created: function(){
            this.lang = this.$i18n.locale;
        },
        mounted: function(){
            var self = this;
            Bus.$on("lang", (lang) => {
                if(lang === "hu"){
                    self.lang = "hu";
                }else{
                    self.lang = "en";
                }
            });
        },
        watch: {
            lang: function(){
                if(this.lang === "hu"){
                    history.pushState('', "Kapcsolat", "https://ijaszat.eu/kapcsolat");
                }else{
                    history.pushState('', "Contact", "https://ijaszat.eu/contact");
                }
            }
        },
        metaInfo() {
            return {
                titleTemplate: chunk => (
                    this.lang === 'hu'
                    ? 'Csodaszarvas Íjászbarlang - Kapcsolat'
                    : 'Csodaszarvas Íjászbarlang - Contact'
                ),
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: this.lang === 'hu' ? 'Gyere íjászkodni a hét minden napján. Fedett, 6 lőállásos pályáinkon készülthetsz versenyekre, de ha még nem próbáltad ezt a sportot, arra is van lehetőség. Vár a Csodaszarvas Íjászbarlang Buda szívében.' : 'In the heart of Buda there is only one archery range awaiting those who are interested in the challenges of archery. Come and try it!',
                    },
                    {
                        vmid: 'og:description',
                        name: 'og:description',
                        content: this.lang === 'hu' ? 'Gyere íjászkodni a hét minden napján. Fedett, 6 lőállásos pályáinkon készülthetsz versenyekre, de ha még nem próbáltad ezt a sportot, arra is van lehetőség. Vár a Csodaszarvas Íjászbarlang Buda szívében.' : 'In the heart of Buda there is only one archery range awaiting those who are interested in the challenges of archery. Come and try it!',
                    },
                    {
                        vmid: 'og:title',
                        property: 'og:title',
                        content: this.lang === 'hu' ? 'Csodaszarvas Íjászbarlang - Kapcsolat' : 'Csodaszarvas Íjászbarlang - Contact',
                    }
                ]
            };
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/Contact.vue